module.exports = __webpack_public_path__ + "4d25478b62f131a69fceac12dfa6891f.svg";